import React from 'react';
import { Alert } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useUserData } from '../contexts/UserDataContext';

const FreeTrialBanner = React.memo(() => {
  const { userProfile } = useUserData();

  // Don't show banner for admin users
  if (userProfile?.app_role === 'admin') {
    return null;
  }

  return (
    <Alert
      message={
        <span>
          <ClockCircleOutlined style={{ marginRight: 8 }} />
          <strong>Free Trial Active</strong> - Upgrade to unlock unlimited projects and advanced features
        </span>
      }
      type="info"
      banner
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1099,
        textAlign: 'center',
        fontWeight: 'bold',
        borderRadius: 0
      }}
    />
  );
});

FreeTrialBanner.displayName = 'FreeTrialBanner';

export default FreeTrialBanner;
